<template>
  <div>
    <div class="uzy-content">
      <div class="top">
        <div class="top-head">
          <div class="top-left">
            <div>全国服务热线：</div>
            <div class="top-phone">18833668068 15933069133</div>
          </div>
          <div class="top-right">
            <div class="item" v-for="(item,index) of top" :key='index' @click="onUrl(item)">
              <img :src="item.src" class="icon" />
              <div>{{item.text}}</div>
              <div class="hoves" style="text-align: center;">
                <img :src="item.img" style="width: 100%;" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="uzy-header-wrap">
        <div class="uzy-head">
          <div style="display: flex;align-items: center;">
            <img src="https://dreamossbucket.oss-cn-beijing.aliyuncs.com/dream/logo.png" style="width: 40px;height: 40px;" />
            <img class="uzy-head-logo" src="https://dreamossbucket.oss-cn-beijing.aliyuncs.com/dream/logo.jpg" object-fit='scale-down'
              style="width: 150px;margin: 0 14px;" />
            <!-- <div class="home-select">志愿指导分析系统</div> -->
            <div class="gaokaoType"></div>
          </div>
        </div>
        <div class="uzy-something">
          <div class="uzy-header-search">
            <input type="text" value placeholder="搜文章 / 找大学 / 查专业 / 看职业 / 搜课程" class="f14" disabled>
            <img src="https://dreamossbucket.oss-cn-beijing.aliyuncs.com/dream/search.png" class="searchIcon" disabled />
          </div>
          <div class="fright">
          </div>
       </div>
     </div>

      <div class="uzy-nav-wra">
        <div class="uzy-nav-box">
          <div class="uzy-nav">
            <ul style="display: flex;">
              <li v-for="(item,index) of navs" :key='index' :class="[0 == index?'nav-sel':'']"
                style="position: relative;" @click="toPage(item.url)">
                <a :title="item">
                  {{item.title}}
                  <i class="iconfont iconarrow-right-copy-copy2" v-if="index"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="user-info">
            <div v-if="user" class="fright">
              <img src="https://dreamossbucket.oss-cn-beijing.aliyuncs.com/dream/user.png" style="margin-right: 5px;width: 20px;height: 20px;"
                @click="toPage('/my')" />
              <span class="name" @click="toPage('/my')">{{user.name}}</span>
              <div class="line"></div>
              <div class="fleft" @click="out()">退出</div>
            </div>
            <div v-else class="fleft ml15" @click="dialogVisible = true">登录</div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <router-view ref="mychild"></router-view>
    </div>

    <div class="floor">
      <div class="w1200">
        <el-row class="logo" type="flex" align="middle" justify="center">
          <img src="https://dreamossbucket.oss-cn-beijing.aliyuncs.com/dream/logo.png" />
          龙门圆梦阁
        </el-row>
        <el-row class="mt10">
          <el-col>
            <div>全国服务电话：18833668068 邮箱：37264003@qq.com</div>
            <a href="https://beian.miit.gov.cn/">ICP备案号：鲁ICP备19024284号-1</a>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- ***********************  登录  **************************-->

    <el-dialog title="" :visible.sync="dialogVisible" width="400px">
      <div class="login-box">
        <div class="login-title">账号密码登录</div>
        <el-input class="login-input" v-model="username" placeholder="请输入姓名"></el-input>
        <el-input class="login-input" type="password" v-model="password" placeholder="请输入密码"></el-input>
        <el-button class="login-button" type="primary" @click="login()" :loading="loginLoading">登录</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        loginLoading: false,
        top: [{
          src: 'https://dreamossbucket.oss-cn-beijing.aliyuncs.com/dream/help.png',
          img: 'https://dreamossbucket.oss-cn-beijing.aliyuncs.com/dream/wang.png',
          text: '帮助'
        }],
        user: null,

        username: '',
        password: '',

        navs: [{
          title: '首页',
          url: '/'
        }, {
          title: '专业指南',
          url: '/zybd/'
        }, {
          title: '提前批',
          url: ''
        }, {
          title: '课堂',
          url: ''
        }, {
          title: '专家服务',
          url: ''
        }, {
          title: '活动',
          url: ''
        }, {
          title: '学友圈',
          url: ''
        }, {
          title: '阳光高考',
          url: 'https://gaokao.chsi.com.cn/'
        }, {
          title: '河北省教育考试院',
          url: 'http://www.hebeea.edu.cn/'
        }],
      }
    },
    mounted() {
      this.user = this.$localStorage.getStorage("user")
    },
    methods: {
      toPage(url) {
        if (url == '')
          return

        if (url.includes("http")) {
          window.open(url)
          return
        }

        this.$router.push({
          path: url
        })
      },
      login() {
        if (this.username == '') {
          this.$message.error('请输入姓名')
          return
        }
        if (this.password == '') {
          this.$message.error('请输入密码')
          return
        }

        this.loginLoading = true
        this.$api.post('user/login', {
          username: this.username,
          password: this.password
        }, res => {
          if (res.state == 1) {
            this.$message.error(res.errMsg)
            return
          }
          this.loginLoading = false
          this.$localStorage.setStorage("user", res.user)
          this.$localStorage.setStorage("token", res.token)
          location.reload()
        })
      },
      out() {
        this.$alert('退出后不可查看和操作报名', '确定要退出吗？', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              this.$localStorage.removeStorage("user")
              this.$localStorage.removeStorage("token")
              location.reload()
            }
          }
        });
      }
    }
  }
</script>

<!-- 上面 -->
<style>
  .tip2 {
    font-size: 13px;
    color: #00d4ff;
    margin-left: 20px;
  }

  .dis {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .big-tip {
    color: #888888;
    font-size: 12px;
    font-weight: 700;
    width: 80px;
  }

  .tipmes {
    font-size: 12px;
    color: #888888;
    margin: 0px 10px;
  }

  .w150 {
    width: 150px;
  }

  h1 {
    font-size: 30px;
    font-weight: 700;
    color: #00d4ff;
    text-align: center;
    padding-bottom: 30px;
  }

  .wsxx-box {
    width: 50vw;
    padding: 30px;
    background-color: #f8f8f8;
    position: relative;
  }

  .wsxx {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    background-color: rgba($color: #000000, $alpha: .3);
  }

  .iconcha {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #ccc;
    font-size: 16px;
    cursor: pointer;
  }

  /* // --------------------------------------------     填报输入 ↓   ------------------------------------------------- */

  .hang {
    display: flex;
    align-items: center;
    padding: 0 65px;
    margin-bottom: 20px;

    .left {
      width: 74px;
    }

    .el-input {
      width: 200px;
    }

    .qujian {
      margin-left: 10px;
      background: #f8f8f8;
      line-height: 40px;
      padding: 0 20px;
      border-radius: 5px;
      color: #999;
    }
  }

  .xuanke {
    display: flex;
    flex-wrap: wrap;
    width: 400px;

    >div {
      justify-content: center;
      width: 78px;
      line-height: 40px;
      height: 42px;
      margin-bottom: 10px;
      border: 1px solid #dcdfe6;
      text-align: center;
      margin-right: 20px;
      cursor: pointer;
      position: relative;

      .el-icon-success {
        position: absolute;
        right: -8px;
        top: -8px;
        font-size: 19px;
        background: #f8f8f8;
      }
    }

    .sel {
      color: #00d4ff;
      border-color: #00d4ff;
    }

    .submit {
      width: 150px;
      background-color: #00d4ff;
      color: #f8f8f8;
    }
  }

  /* // --------------------------------------------     填报输入 ↑    ------------------------------------------------- */

  .selAddrDialog {
    .dialogTitle {
      color: #f8f8f8;
      text-align: center;
      font-size: 30px;

      .el-icon-s-flag {
        color: red;
      }
    }

    .dialogSubTitle {
      text-align: center;
      margin: 17px;
      color: darksalmon;
      font-size: 16px;
    }

    .dialogContent {
      display: flex;
      flex-wrap: wrap;
      color: #f8f8f8;
      justify-content: space-between;

      >div {
        border: 1px solid;
        width: 83px;
        text-align: center;
        line-height: 36px;
        border-radius: 5px;
        margin: 10px 5px;
        cursor: pointer;
      }
    }
  }

  a {
    cursor: pointer;
  }

  .name {
    max-width: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .nav-sel {
    background-color: #00d4ff;
  }

  .uzy-nav-wra {
    background: linear-gradient(135deg, #00d4ff 0%, #0a0e27 50%, #0a0e27 100%);
    width: 100%;
    height: 40px;
    position: relative;
    z-index: 100;
  }

  .more>.left>.top>.iconfont {
    margin-right: 5px;
  }

  .more>.left>.top {
    color: #f8f8f8;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 30px;
  }

  .more>.left {
    width: 105px;
    padding-right: 15px;
    padding: 10px 15px 40px 15px;
  }

  .gaokaoType {
    color: #00d4ff;
    font-size: 15px;
  }

  .home-select {
    border: 1px solid #aaa;
    padding: 10px 26px;
    font-size: 23px;
    color: blue;
    background: beige;
  }

  .more>.left>.bottom {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .nav {
    color: #f8f8f8;
    /* padding-top: 8px; */
    font-size: 14px;
    line-height: 28px;
    font-weight: 300;
  }

  .nav:hover {
    color: #ccc;
  }

  .more2 {
    width: 144px;
  }

  .more1 {
    width: 128px;
  }

  .more {
    left: 0px;
    top: 40px;
    right: 0px;
    background-color: rgba(0, 0, 0, .8);
    padding: 10px 18px;
    display: flex;
    position: absolute;
    box-sizing: border-box;
    justify-content: center;
    flex-direction: column;
  }

  .more3 {
    width: 411px;
    left: -137px;
    flex-direction: row !important;
    justify-content: flex-start !important;
    padding: 0px !important;
  }

  .font>.img:hover {
    margin-top: -10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .2);
  }

  .line1 {
    display: flex;
    line-height: 40px;

    div {
      border-right: 1px solid #ccc;
      width: 124px;
      text-align: center;
    }
  }

  .font>.img {
    transition: all 0.2s linear;
  }

  .uzy-copyright span.line {
    border-right: 1px solid #868686;
  }

  .uzy-foot-wraV2 .uzy-copyright {
    background: #333333;
  }

  .uzy-copyright {
    color: #868686;
    line-height: 18px;
    font-size: 12px;
    text-align: center;
    padding: 10px 0;
    background: #e4e4e4;
  }

  .uzy-copyright span {
    padding: 0 10px;
  }

  .uzy-copyright span a {
    color: #868686;
  }

  .pull-left {
    float: left;
  }

  .uzy-foot-wraV2 .uzy-foot .foot-right .hot-line p.tel {
    font-size: 30px;
    font-weight: 400;
    color: #00d4ff;
    margin-bottom: 10px;
    text-align: right;
    line-height: 25px;
  }

  .uzy-foot .foot-right .hot-line p {
    font-size: 14px;
    color: #868686;
    line-height: 25px;
  }

  .mt20 {
    margin-top: 20px !important;
  }

  .mt5 {
    margin-top: 5px !important;
  }

  a:link,
  a:visited {
    color: #333;
    text-decoration: none;
  }

  a,
  a:focus,
  button {
    outline-style: none;
    -moz-outline-style: none;
  }

  .uzy-foot-wraV2 .uzy-foot .nav h3 {
    color: #999;
  }

  .uzy-foot-wraV2 .uzy-foot .nav ul li a {
    color: #777;
  }

  .uzy-foot .nav ul li a {
    color: #999;
  }

  .uzy-foot .nav h3 {
    margin-bottom: 10px;
    color: #f66;
    font-size: 16px;
    text-align: left;
    font-weight: 400;
  }

  .uzy-foot .nav ul li {
    float: left;
    text-align: left;
    font-size: 14px;
    width: 100px;
    line-height: 25px;
  }

  .uzy-foot-wraV2 .uzy-foot .foot-right .hot-line {
    width: auto;
    padding-left: 20px;
    display: inline-block;
  }

  .uzy-foot-wraV2 .uzy-foot .foot-right .block-erweima p {
    font-size: 12px;
    color: #777;
    margin-top: 10px;
    text-align: center;
  }

  .uzy-foot-wraV2 .uzy-foot .foot-right .hot-line {
    width: auto;
    padding-left: 20px;
    display: inline-block;
  }

  .uzy-foot .nav {
    float: left;
    width: 100px;
    text-align: center;
    margin: 0 60px 0 0;
  }

  .uzy-foot-wraV2 .uzy-foot .foot-right {
    width: 340px;
    height: auto;
    float: right;
    padding-left: 25px;
    text-align: left;
  }

  .uzy-foot-wraV2 .uzy-foot .section {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
  }

  .uzy-foot-wraV2 .uzy-foot {
    width: 100%;
    background: #2c3e50;
    height: auto;
    margin: 0 auto;
    margin-top: 30px;
    padding-bottom: 10px;
  }

  .clearfix {
    overflow: hidden;
  }

  .uzy-foot-wraV2 .uzy-action {
    background: #f5f4f8;
    width: 1200px;
    height: auto;
    overflow: hidden;
    margin: 0 auto;
  }

  .uzy-foot-wra .uzy-action .section {
    width: 1200px;
    margin: 0 auto;
    height: auto;
    color: #f8f8f8;
    overflow: hidden;
    padding: 20px 0;
  }

  .uzy-foot-wraV2 .uzy-action .section .font {
    margin-right: 18px;
    width: auto;
    float: left
  }

  .mr0 {
    margin-right: 0 !important;
  }

  .uzy-foot-wra {
    width: 100%;
    height: auto;
    background: #f8f8f8;
    *zoom: 1;
    overflow: hidden;
  }

  .uzy-foot-wraV2 .uzy-links {
    width: 1200px;
    margin: 15px auto 0;
  }

  .uzy-foot-wraV2 .uzy-links .section {
    background: #f8f8f8;
    padding: 20px 15px;
  }

  .uzy-foot-wraV2 .uzy-links .section .home-title {
    border-bottom: 1px solid #f0f0f0;
    overflow: hidden;
    border-left: 0;
    padding: 0;
    height: 44px;
    line-height: 44px;
    font-size: 24px;
  }

  .uzy-foot-wraV2 .uzy-links ul li {
    float: left;
    margin: 5px 0;
    font-size: 12px;
    margin-right: 10px;
  }

  .fright>.line {
    width: 1px;
    height: 10px;
    margin: 0 15px;
    background-color: rgba(255, 255, 255, .4);
  }

  .ml15 {
    margin-left: 15px;
  }

  .mr15 {
    margin-right: 15px !important;
  }

  .fleft {
    cursor: pointer;
    float: left !important;
    line-height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  .user-info {
    height: 40px;
    line-height: 40px;
    color: #f8f8f8;
    float: right;
  }

  .uzy-nav ul>li>a>i {
    font-size: 12px;
    margin-right: 5px;
    padding-left: 5px;
  }

  a,
  a:focus,
  button {
    outline-style: none;
    /* -moz-outline-style: none; */
  }

  a:link,
  a:visited {
    color: #333;
    text-decoration: none;
  }

  li {
    list-style-type: none;
  }

  .uzy-nav ul li a {
    color: #f8f8f8;
  }

  .uzy-nav ul>li {
    padding: 0 18px;
    height: 40px;
    /* float: left; */
    font-weight: 700;
    cursor: pointer;
  }

  .uzy-nav ul>li:hover {
    background: #00d4ff;
  }

  .user-info {
    height: 40px;
    line-height: 40px;
    color: #f8f8f8;
    float: right;
  }

  .uzy-nav {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    float: left;
    position: relative;
  }

  .uzy-nav-box {
    width: 1230px;
    height: 40px;
    margin: 0 auto;
  }

  .fright {
    float: right !important;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .uzy-gaokao-date.applyFor-vip .lighting {
    width: 25px;
    height: 52px;
    position: absolute;
    top: -5px;
    left: -49px;
    transform: rotate(15deg);
    -webkit-transform: rotate(15deg);
    -webkit-animation: lightingVip 1s linear infinite forwards;
    -moz-animation: lightingVip .8s linear infinite forwards;
    animation: lightingVip .8s linear infinite forwards;
    background: rgba(255, 255, 255, .4);
    z-index: 1
  }

  @keyframes lightingVip {
    20% {
      left: -49px
    }

    100% {
      left: 90px
    }
  }

  @-webkit-keyframes lightingVip {
    20% {
      left: -49px
    }

    100% {
      left: 90px
    }
  }

  .uzy-gaokao-date.applyFor-vip1 .lighting {
    width: 25px;
    height: 52px;
    position: absolute;
    top: -5px;
    left: -49px;
    transform: rotate(15deg);
    -webkit-transform: rotate(15deg);
    -webkit-animation: lightingVip1 2s linear infinite forwards;
    -moz-animation: lightingVip1 1.6s linear infinite forwards;
    animation: lightingVip1 1.6s linear infinite forwards;
    background: rgba(255, 255, 255, .4);
    z-index: 1
  }

  @keyframes lightingVip1 {
    20% {
      left: -49px
    }

    100% {
      left: 290px
    }
  }

  @-webkit-keyframes lightingVip1 {
    20% {
      left: -49px
    }

    100% {
      left: 290px
    }
  }


  .uzy-gaokao-date.applyFor-vip2 .lighting {
    width: 25px;
    height: 52px;
    position: absolute;
    top: -5px;
    left: -49px;
    transform: rotate(15deg);
    -webkit-transform: rotate(15deg);
    -webkit-animation: lightingVip2 3s linear infinite forwards;
    -moz-animation: lightingVip2 2.6s linear infinite forwards;
    animation: lightingVip2 2.6s linear infinite forwards;
    background: rgba(255, 255, 255, .4);
    z-index: 1
  }

  @keyframes lightingVip2 {
    20% {
      left: -49px
    }

    100% {
      left: 930px
    }
  }

  @-webkit-keyframes lightingVip2 {
    20% {
      left: -49px
    }

    100% {
      left: 930px
    }
  }

  .applyFor-vip {
    cursor: pointer;
    background: #00d4ff;
    color: #f8f8f8 !important;
    overflow: hidden;
  }

  .applyFor-vip1 {
    cursor: pointer;
    background: #00d4ff;
    color: #f8f8f8 !important;
    overflow: hidden;
  }

  .applyFor-vip2 {
    cursor: pointer;
    background: #00d4ff;
    color: #f8f8f8 !important;
    overflow: hidden;
  }

  .uzy-gaokao-date {
    font-size: 14px;
    height: 39px;
    position: relative;
    line-height: 39px;
    border: 1px solid #00d4ff;
    /* float: left; */
    padding: 0 10px;
    color: #00d4ff;
    margin-left: -1px;
  }

  .searchIcon {
    position: absolute;
    top: 10px;
    right: 15px;
    width: 21px;
    height: 21px;
    cursor: pointer;
  }

  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #B0B0B0 !important;
  }

  .uzy-header-search input {
    padding-left: 40px;
    box-sizing: border-box;
    width: 100%;
    /* float: left; */
    padding: 3px 6px;
    box-shadow: none;
    font-size: 16px;
    line-height: 33px;
    font-size: 14px !important;
    border: none;
    outline: none;
    border: 1px solid #00d4ff;
    transition: all .3s linear;
  }

  .uzy-header-search input:focus {
    border-color: #00d4ff;
  }

  .uzy-header-search {
    width: 325px;
    height: 28px;
    margin-top: -15px;
    position: relative;
  }

  .uzy-header-tv {
    height: 39px;
    /* background-color: red; */
    position: relative;
    color: #00d4ff;
    cursor: pointer;
    font-size: 14px;
    padding: 0px 10px;
    display: flex;
    align-items: center;
    border: 1px solid #00d4ff;
    margin-right: 12px;
    /* float: left; */
  }

  .uzy-header-wrap>.uzy-something {
    justify-content: flex-end;
    width: 740px;
    align-items: center;
    height: 44px;
    display: flex;
  }

  .iconarrow-down {
    color: #00d4ff;
    margin-left: 5px;
  }

  .gray {
    font-size: 14px;
    color: #333333;
  }

  .uzy-zone-select {
    width: 70px;
    height: 30px;
    border: 1px solid #ccc;
    line-height: 30px;
    text-align: center;
  }

  .uzy-head-logo {
    width: 264px;
  }

  .uzy-zone-select-box {
    width: 110px;
    height: 58px;
    display: flex;
    align-items: center;
    /* background-color: pink; */
  }

  .uzy-head {
    width: 690px;
    height: 44px;
    display: flex;
    align-items: center;
    /* background-color: red; */
    /* float: left;
  		    float: left!important; */
  }

  .uzy-header-wrap {
    width: 1235px;
    height: 44px;
    margin: 0 auto;
    *zoom: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 999;
  }

  .uzy-content>.top {
    /* padding: 8px; */
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #0f1530;
    font-size: 12px;
    box-sizing: border-box;
    justify-content: center;
  }

  .top-head {
    line-height: 30px;
    width: 1200px;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
  }

  .top-left {
    color: #0a0e27;
    width: 600px;
    display: flex;
    align-items: center;
    /* background-color: red; */
  }

  .top-phone {
    color: #00d4ff;
    font-size: 14px;
    font-weight: 500;
  }

  .top-right {
    width: 600px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 30px;
    color: #999;
    position: relative;
  }

  .icon {
    width: 20px;
    height: 20px;
    margin-right: 2px;
  }

  .top-right .item {
    margin-left: 25px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    /* background-color: red; */
  }

  .top-right .item:hover {
    color: #000;
  }

  .top-right .item:hover>.hoves {
    display: block;
  }

  .hoves {
    width: 220px;
    height: 220px;
    /* background-color: rgba(0,0,0,.5); */
    position: absolute;
    bottom: -220px;
    left: -100px;
    display: none;
    z-index: 10000;
  }
</style>

<!-- 登录 -->
<style>
  .login-box {
    padding-bottom: 20px;
  }

  .login-title {
    margin: 0;
    float: left;
    font-size: 20px;
    color: #0a0e27;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .login-input {
    line-height: 50px;
    color: #555;
  }

  .login-button {
    display: block;
    height: 45px;
    font-size: 16px;
    font-weight: bold;
    border: 0;
    cursor: pointer;
    background: linear-gradient(135deg, #00d4ff 0%, #0a0e27 100%);
    color: #FFF;
    text-align: center;
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(93,95,239,0.4);
  }
</style>

<style scoped>
  /* 底部 */
  .floor {
    background: linear-gradient(135deg, #050816 0%, #050816 100%);
    padding: 8px 20px 12px;
    color: #0a0e27;
    text-align: center;
    font-size: 10px;
    line-height: 14px;
  }

  .floor .remark {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .floor .logo {
    font-size: 12px;
    font-weight: 400;
  }

  .floor .logo img {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .floor a {
    display: block;
    color: #0a0e27;
  }

  .floor a:hover {
    color: #f8f8f8;
  }

  .floor .el-row {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue